export enum NewsOrigin {
    SpreadsheetImport = 1,
    AutomaticClipping = 2
}